import { isFunction } from 'lodash'
import { createStore } from 'zustand'

import { DraggableModalStore } from './interface'

export const createDraggableModalStore = () =>
  createStore<DraggableModalStore>((set, get) => ({
    id: '',
    coordinates: { x: 0, y: 0 },
    setCoordinates(coordinates) {
      if (isFunction(coordinates)) {
        set({ coordinates: coordinates(get().coordinates) })
      } else {
        set({ coordinates })
      }
    },
    attributes: {
      role: '',
      tabIndex: 0,
      'aria-disabled': false,
      'aria-pressed': undefined,
      'aria-roledescription': '',
      'aria-describedby': ''
    },
    listeners: {},
    setNodeRef: () => {},
    transform: ''
  }))
